






















































import { IFormSection } from '@/models';
import Vue, { PropType } from 'vue';
import FormBuilderTemplateFields from './FormBuilderTemplateFields.vue';
export default Vue.extend({
  components: { FormBuilderTemplateFields },

  props: {
    section: Object as PropType<IFormSection>,
    canRemove: Boolean,
    loading: Boolean,
    disabled: Boolean
  },

  methods: {
    openDrawer(fieldIndex?: number) {
      this.$emit('openDrawer', fieldIndex);
    },

    openFieldTypeDrawer() {
      this.$emit('openFieldTypeDrawer');
    },

    addSection() {
      this.$emit('addSection');
    },

    removeSection() {
      this.$emit('removeSection');
    },

    save() {
      this.$emit('save');
    }
  }
});
